import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CasesService } from 'src/app/services/cases.service';
import { CommonService } from 'src/app/services/common.service';
import { GoogleAnalyticsEventsService } from 'src/app/services/google-analytics-events.service';
import { AcceptModalComponent } from '../accept-modal/accept-modal.component';
import { PrinterService } from 'src/app/services/printer.service';
import { forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-case-dialog',
  templateUrl: './add-case-dialog.component.html',
  styleUrls: ['./add-case-dialog.component.scss']
})
export class AddCaseDialogComponent implements OnInit {

  @Input() isLoading = true;
  page1Form: any;
  customerDetailForm: any;
  isPreviousButtonHidden = false
  pageNumber: number
  customerList = []
  printerList = []
  printerFunctioning = []
  caseTypeList = []
  caseContactList = []
  assingToList = []
  steps = []
  selectedCompany = []
  companyID = ""
  selectedPrinter = []
  product_number = ""
  serial_number = ""
  selectedPrinterFunc = []
  selectedCase = []
  subject = ""
  detail = ""
  selectedContact = []
  selectedAssignee = []
  errorCodeList = []
  maintenanceList = []
  selectedMaintenance = []
  selectedErrorCode = []
  selectedJob = []
  body: any;
  newCaseId: any;
  isNewContact: boolean
  alertArray = []
  fname = ''
  lname = ''
  email = ''
  phone = ''
  jobList = []
  supportedModels = []
  supportedModelWithPrintosStatus = []
  newCustContactID = ''
  copyData: any
  disabledCompany: boolean = false;
  disabledPrinter: boolean = false;
  disabledCase: boolean = false;
  validEmail: boolean = false
  validPhone: boolean = false
  isProactive: boolean = false;
  isCustomerDetail = false;

  companyStatus: boolean;
  modelStatus: boolean;
  functionStatus: boolean;
  typeStatus: boolean;
  contactStatus: boolean;
  assignStatus: boolean;
  maintStatus: boolean;
  errorStatus: boolean;
  jobStatus: boolean;
  currentUser = [];
  alertID: any;
  origin: boolean = false;
  c_id: any;
  pId: any;
  errorCd: any;
  // page 1 dropdown
  companyDropdown = [
    {
      label: '',
      ariaLabel: 'ADD_CASE.COMPANY',
      placeholder: 'DROP_DOWN.LABEL',
      isSearchable: false,
      isCustomer: false,
      isOptional: false,
      addNew: false,
      isRequired: true,
      hideAsterik : true,
      errorMessages: {
        required: "ADD_CASE.COMPANY_ERROR",
      }
    }]
  printerModel = 'ADD_CASE.MODEL'
  printerMoedelReq = 'ADD_CASE.PRINTER_ERROR'
  deviceModeReq = 'DEVICE_MODEL_REQ_ERROR'
  deviceModel = "DEVICE_MODEL"
  printerDropdown = [
    {
      label: '',
      ariaLabel: this.deviceModel,
      placeholder: 'DROP_DOWN.LABEL',
      isSearchable: true,
      isCustomer: false,
      isOptional: false,
      addNew: false,
      isRequired: true,
      hideAsterik : true,
      searchText: 'ADD_CASE.PRINTER_SEARCH',
      errorMessages: {
        required: this.deviceModeReq
      }
    }]

  printerFuncDropdown = [
    {
      label: '',
      ariaLabel: 'DEVICE_FUCNTIONING',
      placeholder: 'DROP_DOWN.LABEL',
      isSearchable: false,
      isCustomer: false,
      isOptional: false,
      addNew: false,
      hideAsterik : true,
      isRequired: true,
      errorMessages: {
        required: "DEVICE_FUCNTIONING_REQ",
      }
    }]

  // page 2 dropdown
  caseTypeDropdown = [
    {
      label: '',
      ariaLabel: 'ADD_CASE.CASE',
      placeholder: 'DROP_DOWN.LABEL',
      isSearchable: false,
      isCustomer: false,
      isOptional: false,
      addNew: false,
      hideAsterik : true,
      isRequired: true,
      errorMessages: {
        required: "ADD_CASE.CASE_TYPE_ERROR",
      }
    }]

  maintenanceDropdown = [
    {
      label: '',
      ariaLabel: 'ADD_CASE.MAINTENANCE',
      placeholder: 'DROP_DOWN.LABEL',
      isSearchable: false,
      isCustomer: false,
      isOptional: false,
      addNew: true,
      hideAsterik : true,
      isRequired: true,
      addNewText: "ADD_CASE.MAINT_1",
      addNewPlaceHolder: "ADD_CASE.MAINT_2",
      errorMessages: {
        required: "ADD_CASE.MAINTENANCE_ERROR",
      },
      source: "Error",
      newCode: true
    }]

  errorCodeDropdown = [
    {
      label: '',
      ariaLabel: 'ADD_CASE.ERROR',
      placeholder: 'DROP_DOWN.LABEL',
      isSearchable: false,
      isCustomer: false,
      isOptional: false,
      addNew: true,
      hideAsterik : true,
      isRequired: true,
      addNewText: "ADD_CASE.MAINT_1",
      addNewPlaceHolder: "ADD_CASE.ERROR_2",
      errorMessages: {
        required: "ADD_CASE.ERROR_CODE_ERROR",
      },
      source: "Error",
      newCode: true
    }]

  caseContact = [
    {
      label: '',
      ariaLabel: 'ADD_CASE.CASE_CONTACT',
      placeholder: 'DROP_DOWN.LABEL',
      isSearchable: false,
      isCustomer: true,
      isOptional: true,
      addNew: false,
      hideAsterik : true,
      searchText: "ADD_CASE.CASE_CONTACT_SEARCH",
      optional: true
    }]
  jobDropdown = [
    {
      label: '',
      ariaLabel: 'ADD_CASE.JOB_TITLE',
      placeholder: 'DROP_DOWN.LABEL',
      isSearchable: false,
      isCustomer: false,
      hideAsterik : true,
      isOptional: false,
      addNew: false,
      isRequired: true,
      errorMessages: {
        required: "ADD_CASE.JOB_ERROR",
      }
    }]

  assignDropdown = [
    {
      label: '',
      ariaLabel: 'ADD_CASE.ASSIGN_TO',
      placeholder: 'DROP_DOWN.LABEL',
      isSearchable: false,
      isCustomer: false,
      isOptional: true,
      hideAsterik : true,
      addNew: false,
      searchText: "ADD_CASE.ASSIGN_SEARCH",
      optional: true
    }]
  detailData = {
    label: "",
    placeHolder: " ",
    ariaLabel: "ADD_CASE.DETAIL",
    isRequired: true,
    errorMessages: {
      required: "ADD_CASE.DETAIL_ERROR",
    }
  }
  subjectData = {
    label: "",
    placeHolder: " ",
    ariaLabel: "ADD_CASE.SUBJECT",
    isRequired: true,
    errorMessages: {
      required: "ADD_CASE.SUBJECT_ERROR",
      pattern: "Invalid subject length."
    }
  }
  fnameData = {
    label: "",
    placeHolder: " ",
    ariaLabel: 'ADD_CASE.FIRST_NAME',
    isRequired: true,
    errorMessages: {
      required: "ADD_CUSTOMER.FIELDS.PAGE2.FIRST_NAME_ERROR",
    }
  }
  lnameData = {
    label: "",
    placeHolder: " ",
    ariaLabel: "ADD_CASE.LAST_NAME",
    isRequired: true,
    errorMessages: {
      required: "ADD_CUSTOMER.FIELDS.PAGE2.LAST_NAME_ERROR",
    }
  }
  emailData = {
    label: "",
    placeHolder: " ",
    ariaLabel: "ADD_CASE.EMAIL",
    isRequired: true,
    errorMessages: {
      required: "ADD_CUSTOMER.FIELDS.PAGE1.EMAIL_ERROR",
      pattern: "DASHBOARD.SITE_PREP.NEW_SITE_PREP.VALIDATION.EMAIL.INVALID"
    }
  }
  phoneData = {
    label: "",
    placeHolder: " ",
    ariaLabel: "ADD_CASE.PHONE_NUMBER",
    isRequired: true,
    errorMessages: {
      required: "ADD_CUSTOMER.FIELDS.PAGE1.PHONE_ERROR",
      pattern: "DASHBOARD.SITE_PREP.NEW_SITE_PREP.VALIDATION.PHONE.INVALID"
    }
  }


  targetedDropdown = [
    {

      label: '',
      ariaLabel: 'CASE_STRINGS.TARGET.PLACEHOLDER',
      placeholder: 'DROP_DOWN.LABEL',
      isSearchable: false,
      isCustomer: false,
      isOptional: false,
      hideAsterik : true,
      addNew: true,
      isRequired: true,
      errorMessages: {
        required: "CASE_STRINGS.TARGET.REQ",
      }
    }]


  legendsList = [
    { label: 'PROACTIVE_ALERT_PAGE.ACTIVITY_LIST.SYSTEM_ERRORS', value: 'systemerrors', code: 'Break & Fix', active: false },
    { label: 'PROACTIVE_ALERT_PAGE.ACTIVITY_LIST.SERVICE_MAINTAINANCE', value: 'smaintenance', code: 'Maintenance', active: false },
    { label: 'PROACTIVE_ALERT_PAGE.ACTIVITY_LIST.USER_MAINTAINANCE', value: 'umaintenance', code: 'Maintenance', active: false },
    { label: 'PROACTIVE_ALERT_PAGE.ACTIVITY_LIST.FIRMWARE_UPDATE', value: 'fwupgrade', code: 'Firmware Update', active: false },
    { label: 'PROACTIVE_ALERT_PAGE.ACTIVITY_LIST.TARGETED_ACTIONS', value: 'targetedaction', code: 'Targeted Actions', active: false }
  ]

  targetList = [
    { label: 'PROACTIVE_ALERT_PAGE.ACTIVITY_LIST.RETROFIT', value: 'Retrofit', active: false },
    { label: 'PROACTIVE_ALERT_PAGE.ACTIVITY_LIST.OTHER', value: 'Other', active: false }
  ]
  selectedTarget = []
  selectedCaseType = []
  dialogData: any;


  hasCutter = false
  selectedCutterCaseType = []
  selectedDeviceType = []
  selectedProblemLoc = []
  selectedPrinterFuncCopy = []
  selectedDeviceFunc = []
  printerFunctioningCopy = []

  deviceDropdown = [
    {
      label: '',
      ariaLabel: 'DEVICE_TYPE',
      placeholder: 'DROP_DOWN.LABEL',
      isSearchable: false,
      isCustomer: false,
      isOptional: false,
      hideAsterik : true,
      addNew: false,
      isRequired: true,
      errorMessages: {
        required: "DEVICE_REQ_ERROR",
      }
    }]

  problemLocDropdown = [
    {
      label: '',
      ariaLabel: 'PROBLEM_LOCATION',
      placeholder: 'DROP_DOWN.LABEL',
      hideAsterik : true,
      isSearchable: false,
      isCustomer: false,
      isOptional: false,
      addNew: false,
      isRequired: true,
      errorMessages: {
        required: "PROBLEM_LOCATION_REQ",
      }
    }
  ]

  deviceFuncDropdown = [
    {
      label: '',
      ariaLabel: 'DEVICE_FUCNTIONING',
      placeholder: 'DROP_DOWN.LABEL',
      hideAsterik : true,
      isSearchable: false,
      isCustomer: false,
      isOptional: false,
      addNew: false,
      isRequired: true,
      errorMessages: {
        required: "DEVICE_FUCNTIONING_REQ",
      }
    }]

  deviceTypeList = [
    { label: 'DEVICE', value: 'Printer', active: false, code: 'printer' },
    { label: 'PRINTER_CUTTER', value: 'Printer and cutter', active: false, code: 'printer_and_cutter' },
    { label: 'CUTTER', value: 'Cutter', active: false, code: 'cutter' }
  ]

  problemLocationList = [
    { label: 'DEVICE', value: 'Printer', active: false },
    { label: 'CUTTER', value: 'Cutter', active: false }
  ]

  deviceFunctioning = [
    { label: "CUTTING", value: "Cutting", active: false },
    { label: "CUTTING_DIFF", value: "Cutting with difficulties", active: false },
    { label: "CUTTER_DOWN", value: "Cutter is down", active: false }
  ]

  cutterCaseTypeList = [
    { label: "CUTTER_ACCURACY", value: "Cutter accuracy", active: false },
    { label: "DROPDOWN_LIST.TYPE_LIST.RIP", value: "Rip", active: false },
    { label: "DROPDOWN_LIST.TYPE_LIST.OTHER", value: "Other", active: false },
  ]
  printerListCopy: any[];
  CASE_CREATED = 'CASE_CREATED';
  showVeenerLoader = false;
  printosLookup: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddCaseDialogComponent>,
    private caseService: CasesService,
    private router: Router,
    private commService: CommonService,
    public dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private printerServ: PrinterService,
    private googleAnalyticsEventsService: GoogleAnalyticsEventsService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.hasCutter = this.data?.cutter;
    if (!this.hasCutter) {
      this.selectedDeviceType.push(this.deviceTypeList[0])
    }
    this.dialogData = this.data;
    this.pageNumber = 1
    this.caseService.getUserRoles().subscribe(resp => {
      resp.result.job_tiles.map(elem => {
        this.jobList.push({ label: elem.name, value: elem.key })
      })
    })
    let printerApi = this.caseService.getPrinters()
    let supportedModelApi = this.printerServ.getCase_supported_models()
    forkJoin([printerApi, supportedModelApi]).subscribe(resp => {
      this.setData(resp[0].result.customers, resp[1].result)
    })
    this.refreshDropdowns()
  }

  populateDialogdata(data) {
    this.isProactive = false;
    let status = data?.status;
    let id = data?.response;
    let printer_id = data?.response1;
    let custs = [];
    let printers = []
    let caseType = [];
    let errorCode = [];
    let customer = []
    let time;
    if (status == 'customer_detail') {
      this.customerList.forEach(cust => {
        if (id == cust.c_id) {
          cust.active = true
          custs.push(cust);
          customer.push(cust)
          this.disabledCompany = true;
        }
      });
      this.isCustomerDetail = true;
    }
    if (status == 'action_required') {
      this.customerList.forEach(cust => {
        if (id == cust.c_id) {
          custs.push(cust);
          customer.push(cust)
        }
      })
    }

    if (status == 'proactive') {
      this.customerList.forEach(cust => {
        if (id == cust.c_id) {
          cust.active = true
          custs.push(cust);
          customer.push(cust)
          this.disabledCompany = true;
          cust.printers.map(printer => {
            if (printer.device_id == printer_id) {
              printer.active = true
              this.pId = printer.device_id
              this.disabledPrinter = true;
              printers.push({ label: printer.name + " (S/N " + printer.serial_number + ")", value: printer.name + " (S/N " + printer.serial_number + ")", model: printer.model, serial_number: printer.serial_number, device_id: printer.device_id })
            }
          })
        }
      })

      let action = this.data?.value
      this.isProactive = action?.ruleType == 'systemerrors' ? true : false;
      this.origin = action?.ruleType == 'systemerrors' ? true : false;

      if (action?.ruleType == 'Maintenance') {

        this.legendsList.forEach(ele => {
          if (ele.value == 'umaintenance' && action?.userReplaceable) {
            ele.active = true
            this.selectedCaseType = [ele]
          }
          if (ele.value == 'smaintenance' && !action?.userReplaceable) {
            ele.active = true
            this.selectedCaseType = [ele]
          }
        })
      } else {
        this.legendsList.forEach(ele => {
          if (ele.value == action?.ruleType?.toLowerCase()) {
            ele.active = true
            this.selectedCaseType = [ele]
          }
        })
      }

    }
    this.selectedValue('company', customer)
    this.selectedValue('printer', printers)
    if (this.dialogData?.proactive == 'proactive' && data.ruleType == 'fwupgrade') {
      data.case_type = null
    }
    this.caseTypeList.forEach(value => {
      if (value.id == data?.case_type) {
        value.active = true
        this.disabledCase = true
        caseType.push(value)


      }
    })
    this.selectedValue('case', caseType)
    if (status == 'proactive') {
      this.errorCd = data.alerts?.error_code
      this.alertID = data?.alerts?.id
      errorCode.push(data?.alerts)

      this.selectedErrorCode = [{ label: data?.alerts?.error_code, value: data?.alerts?.error_code, error_code: data?.alerts?.error_code, event: data?.alerts?.event_name, timestamp: data?.alerts?.time_stamp, alert_id: data?.alerts?.id, active: true }]
      this.errorCodeList.push(this.selectedErrorCode[0])
      this.selectedValue('error', this.selectedErrorCode)
    }
  }

  cloneSteps(data) {
    return JSON.parse(JSON.stringify(data))
  }

  setData(data, supported_models) {
    if (this.hasCutter) {
      this.steps = this.cloneSteps(this.caseService.stepsCutter);
    } else {
      this.steps = this.cloneSteps(this.caseService.steps);
    }
    for (let i = 0; i < this.steps.length; i++) {
      this.steps[i].completed = false;
    }
    this.steps[0].active = true;
    this.steps[1].active = false;

    data.forEach(item => {
      this.customerList.push({ label: item.company_name, value: item.organization_id, c_id: item.organization_id, printers: item.printers })
    });
    this.customerList = this.customerList.filter((v, i, a) => a.findIndex(t => (t.c_id === v.c_id)) === i)
    this.isLoading = false

    supported_models?.map(model => {
      this.supportedModels.push(model?.name)
      this.supportedModelWithPrintosStatus.push({model: model.name, is_printos: model.is_printos})
    })
    this.supportedModels = this.supportedModels.filter((v, i, a) => a.findIndex(t => (t === v)) === i)

    // remove duplicates from supportedModelWithPrintosStatus
      this.supportedModelWithPrintosStatus = [
        ...new Map(
          this.supportedModelWithPrintosStatus.map(item => [item.model, item])
        ).values()
      ];

    this.printosLookup = this.supportedModelWithPrintosStatus.reduce(
      (acc, item) => {
        acc[item.model] = item.is_printos;
        return acc;
      },
      {} as Record<string, boolean>
    );


    this.populateDialogdata(this.data)
    this.sortList(this.customerList)
    this.page1Form = this.fb.group({
      detail: new UntypedFormControl('', Validators.required),
      subject: new UntypedFormControl('', [Validators.required, Validators.pattern('^(?=.{1,100}$).*')]),
    });

    this.customerDetailForm = this.fb.group({
      fname: new UntypedFormControl('', Validators.required),
      lname: new UntypedFormControl('', Validators.required),
      email: new UntypedFormControl('', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]),
      phone: new UntypedFormControl('', [Validators.required, Validators.pattern('^(( *?[0-9+\\-] *?){8,14}||( *?[0-9\\(\\)] *?){9,14}||( *?[0-9+\\-\\(\\)] *?){10,14}||[0-9]{7,20})$')]),
    });


  }

  sortList(list) {
    list.sort(function (a, b) {
      const v1 = a.label.toLowerCase()
      const v2 = b.label.toLowerCase()
      if (v1 < v2) {
        return -1
      }
      if (v1 > v2) {
        return 1
      }
      return 0
    })
  }

  refreshDropdowns() {
    this.selectedPrinter.splice(0, 1)
    this.selectedPrinterFunc.splice(0, 1)
    this.selectedCase.splice(0, 1)
    this.selectedMaintenance.splice(0, 1)
    this.selectedErrorCode.splice(0, 1)
    this.subject = ""
    this.detail = ""
    this.page1Form?.get('subject')?.setValue("")
    this.page1Form?.get('detail')?.setValue("")
    this.selectedAssignee.splice(0, 1)
    this.selectedContact.splice(0, 1)
    this.caseContactList.splice(0, this.caseContactList.length)
    this.assingToList.splice(0, this.assingToList.length)
    this.printerFunctioning = [
      { label: "DROPDOWN_LIST.PRINTER_FUNC_LIST.PRINTING", value: "Printing", active: false },
      { label: "DROPDOWN_LIST.PRINTER_FUNC_LIST.PRINTING WITH DIFFICULTIES", value: "Printing with difficulties", active: false },
      { label: "DROPDOWN_LIST.PRINTER_FUNC_LIST.PRINTER IS DOWN", value: "Printer is down", active: false }
    ]
    this.caseTypeList = [
      { label: "DROPDOWN_LIST.TYPE_LIST.BREAK", value: "Break & Fix", id: "001", active: false },
      { label: "DROPDOWN_LIST.TYPE_LIST.MAINTANANCE", value: "Maintenance", id: "002", active: false },
      { label: "PROACTIVE_ALERT_PAGE.ACTIVITY_LIST.FIRMWARE_UPDATE_1", value: "Firmware Update", id: "004", active: false },
      { label: "PROACTIVE_ALERT_PAGE.ACTIVITY_LIST.TARGETED_ACTIONS_1", value: "Targeted Actions", id: "005", active: false },
      { label: "DROPDOWN_LIST.TYPE_LIST.OTHER", value: "Other", id: "003", active: false }
    ]

    this.printerFunctioningCopy = JSON.parse(JSON.stringify(this.printerFunctioning));

  }

  close() {
    this.steps[1].active = false;
    this.dialogRef.close();
  }

  loadNextPage() {
    if (this.hasCutter) {
      this.loadCutterNextPage()
    } else {
      if (this.pageNumber == 1) {
        this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Click on Next in a company information step', this.commService.custID, null)
        this.setPageNumber();
      } else if (this.pageNumber == 2 && this.checkValidity()) {
        this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Click on Next in a case information step', this.commService.custID, null)
        this.saveContact();
      }
    }
    setTimeout(()=>{
      document.getElementById('stepper-title')?.focus()
    })

  }

  loadCutterNextPage() {
    if (this.pageNumber == 1) {
      this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Click on Next in a device information step', this.commService.custID, null)
      this.setCutterPageNumber();
    } else if ((this.pageNumber == 2 && this.checkValidity()) || this.selectedCutterCaseType.length > 0) {
      this.saveContact();
    }
    setTimeout(()=>{
      document.getElementById('stepper-title')?.focus()
    })
  }
  setCutterPageNumber() {
    this.pageNumber = 2;
    document.getElementById('steptitle2')?.focus()
    this.steps[0].completed = true;
    this.steps[1].active = true
    this.isPreviousButtonHidden = true
  }

  setCutterPageNumber3() {
    this.pageNumber = 3
    document.getElementById('steptitle3')?.focus()
    this.steps[1].completed = true;
    this.steps[2].active = true
    this.isPreviousButtonHidden = true
  }

  setPageNumber() {
    this.pageNumber = 2
    this.steps[1].active = true
    this.isPreviousButtonHidden = true
  }

  checkValidity() {
    if ((this.selectedCase.length > 0 || this.selectedCaseType.length > 0 || this.selectedTarget.length > 0) && this.subject.length > 0 && this.detail.length > 0) {
      if (this.isNewContact) {
        if (this.customerDetailForm.valid && this.selectedJob.length > 0) {
          return true
        }
      } else { return true }
    }
    this.isLoading = false
  }

  validate(field, value) {
    if (field == 'email') {
      if (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$/.test(value)) {
        this.validEmail = false;
      } else {
        this.validEmail = true;
      }
    }

    if (field == 'phone') {
      if (/^\d{7,20}$/.test(value)) {
        this.validPhone = false;
      } else {
        this.validPhone = true;
      }
    }
  }

  loadPreviousPage() {
    this.pageNumber = this.pageNumber - 1
    this.steps[this.pageNumber].active = false
    this.steps[this.pageNumber - 1].completed = false
    if (this.pageNumber == 1) {
      this.isPreviousButtonHidden = false
    }
  }

  selectedLegend(data) {
    this.legendsList?.map(ele => {
      if (ele.value == data[0]?.value) {
        ele.active = true
        this.selectedCaseType = data
      }
    })
  }

  selectedValue(field, data) {
    switch (field) {
      case 'company':
        if (data.length) {
          this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Click on the company name arrow', this.commService.custID, null)
        }
        this.printerList = []
        this.selectedCompany = data
        this.refreshDropdowns()
        data.length > 0 ? this.setContacts(this.selectedCompany[0].c_id) : this.selectedCompany = []
        data[0]?.printers?.forEach(element => {
          if (this.supportedModels.includes(element?.model)) {
            this.printerList.push(
              {
                label: element.name + " (S/N " + element.serial_number + ")",
                value: element.name + " (S/N " + element.serial_number + ")",
                model: element.model,
                serial_number: element.serial_number,
                device_id: element.device_id,
                is_cutter_model: element.is_cutter_model,
                is_printcut_model: element.is_printcut_model,
                is_printos: this.printosLookup[element.model] ?? false 
              })
          }
        })

        // this.printerList = this.printerList.filter((v, i, a) => a.findIndex(t => (t.serial_number === v.serial_number)) === i)
        this.sortList(this.printerList)
        this.printerList.forEach(element => {
          if (element.device_id == this.pId) {
            element.active = true
          }
        })
        this.printerListCopy = [...this.printerList]

        if (this.selectedDeviceType?.length && this.selectedDeviceType[0]?.value == 'Cutter') {
          this.printerList = this.printerListCopy.filter(ele => ele.is_cutter_model == true)
        } else if (this.selectedDeviceType?.length && this.selectedDeviceType[0]?.value == "Printer and cutter") {
          this.printerList = this.printerListCopy.filter(ele => ele.is_printcut_model == true)
        } else {
          this.printerList = this.printerListCopy.filter(ele => ele.is_cutter_model == false);
        }

        break;

      case 'printer':
        this.selectedPrinter = data
        if (data.length > 0) {
          this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Click on the Printer model arrow', this.commService.custID, null)
          this.product_number = data[0].model;
          this.serial_number = data[0].serial_number
          this.errorCodeList = []
          this.maintenanceList = []
          this.getInfo(this.product_number, this.serial_number)
        }
        break;

      case 'printfunc':
        if (data.length) {
          this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Click on the “Printer functioning” arrow ', this.commService.custID, null)
        }
        data.length > 0 ? this.selectedPrinterFunc = data : this.selectedPrinterFunc = []
        break;

      case 'case':
        if (data.length) {
          this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Click on the Case Type arrow', this.commService.custID, null)
        }
        this.selectedErrorCode.splice(0, this.selectedErrorCode?.length)
        this.selectedMaintenance.splice(0, this.selectedMaintenance?.length)
        data.length > 0 ? this.selectedCase = data : this.selectedCase = []
        break;

      case 'contact':
        data.length > 0 ? this.selectedContact = data : this.selectedContact = []
        data.length > 0 && data[0].contact ? this.isNewContact = true : this.isNewContact = false
        break;

      case 'assign':
        data.length > 0 ? this.selectedAssignee = data : this.selectedAssignee = []
        break;

      case 'maint':
        data.length > 0 ? this.selectedMaintenance = data : this.selectedMaintenance = []
        break;

      case 'error':
        data.length > 0 ? this.selectedErrorCode = data : this.selectedErrorCode = []
        break;

      case 'job':
        data.length > 0 ? this.selectedJob = data : this.selectedJob = []
        break;
      case 'target':
        data.length > 0 ? this.selectedTarget = data : this.selectedTarget = []
        break;
      case 'deviceType':
        this.selectedCutterCaseType = []
        this.selectedTarget = []
        this.selectedCase = []
        this.selectedPrinterFunc = []
        this.selectedDeviceFunc = []
        this.selectedProblemLoc = []
        this.problemLocationList.forEach(ele => ele.active = false)
        this.updatePrinterDeviceLabel()
        data.length > 0 ? this.selectedDeviceType = data : this.selectedDeviceType = []

        if (this.selectedDeviceType[0]?.value == 'Cutter') {
          this.printerList = this.printerListCopy.filter(ele => ele.is_cutter_model == true)
        } else if (this.selectedDeviceType[0]?.value == "Printer and cutter") {
          this.printerList = this.printerListCopy.filter(ele => ele.is_printcut_model == true)
        } else {
          this.printerList = this.printerListCopy.filter(ele => ele.is_cutter_model == false);
        }

        break;
      case 'problemLocation':
        this.selectedPrinterFuncCopy = []
        this.selectedPrinterFunc = []
        this.selectedDeviceFunc = []
        this.selectedTarget = []
        this.selectedCase = []
        this.updatePrinterDeviceLabel()
        data.length > 0 ? this.selectedProblemLoc = data : this.selectedProblemLoc = []
        break;
      case 'deviceFunc':
        if (data.length) {
          this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Click on the “Printer functioning” arrow ', this.commService.custID, null)
        }
        this.selectedPrinterFuncCopy = []
        data.length > 0 ? this.selectedDeviceFunc = data : this.selectedDeviceFunc = []
        break;
      case 'printerFunctioningCopy':
        if (data.length) {
          this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Click on the “Printer functioning” arrow ', this.commService.custID, null)
        }
        this.selectedDeviceFunc = []
        data.length > 0 ? this.selectedPrinterFuncCopy = data : this.selectedPrinterFuncCopy = []
        break;
      case 'cutterCaseType':
        if (data.length) {
          this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Click on the Case Type arrow', this.commService.custID, null)
        }
        data.length > 0 ? this.selectedCutterCaseType = data : this.selectedCutterCaseType = []
        break;
    }

    this.errorCodeList = this.errorCodeList.filter((v, i, a) => a.findIndex(t => (t?.error_code === v?.error_code)) === i)
  }

  updatePrinterDeviceLabel() {
    this.deviceFunctioning.forEach(ele => ele.active = false)
    this.printerFunctioning.forEach(ele => ele.active = false)
    this.printerFunctioningCopy.forEach(ele => ele.active = false)
  }

  setContacts(c_id) {
    this.caseService.getContact(c_id).subscribe(resp => {
      this.setOptionalData('contact', resp.result)
    })
    this.caseService.getAssignees().subscribe(resp => {
      this.setOptionalData('assign', resp.result.users)
    })
  }

  getInfo(model, serial_number) {
    // this.caseService.getAlertsInfo(model, serial_number).subscribe(resp => {
    //   this.setAlerts('alert', resp.result.latest_alerts);
    // })
    this.caseService.getServiceMaintenance(model, serial_number).subscribe(resp => {
      this.setAlerts('maint', resp?.result?.printers[0]?.actions)
    })
  }

  setAlerts(field, data) {

    let maintenanceArray = data?.filter(ele => ele.ruleType == 'Maintenance')
    if (maintenanceArray?.length) {
      maintenanceArray.forEach(res => {
        this.maintenanceList.push({
          label: res.eventCode,
          value: res.eventCode,
          error_code: res.eventCode,
          is_smart_alert: false
        })
      })
    }

    this.maintenanceList = this.maintenanceList.filter((v, i, a) => a.findIndex(t => (t.value === v.value)) === i)



    let errorCodeArray = data?.filter(ele => ele.ruleType == 'SystemErrors')
    if (errorCodeArray?.length) {
      errorCodeArray.forEach(res => {
        this.errorCodeList.push({
          label: res.eventCode,
          value: res.eventCode,
          error_code: res.eventCode,
          event: res.eventName,
          is_smart_alert: false,
          timestamp: res.generateTs,
        })
      })
    }

    this.errorCodeList.push({
      label: 'DROPDOWN_LIST.NO_ERROR',
      value: 'There is no error code',
      error_code: 'There is no error code',
      timestamp: null,
      is_smart_alert: false
    })

    // if (data.length > 0) {
    //   data.map(elem => {
    //     if (field == 'alert') {
    //       this.errorCodeList.push({
    //         label: elem.error_code,
    //         value: elem.error_code,
    //         error_code: elem.error_code,
    //         event: elem.event_name,
    //         timestamp: elem.timestamp,
    //         is_smart_alert: elem.is_smart_alert
    //       })

    //       this.errorCodeList.push({
    //         label: 'DROPDOWN_LIST.NO_ERROR',
    //         value: 'There is no error code',
    //         error_code: 'There is no error code',
    //         timestamp: null,
    //         is_smart_alert: false
    //       })

    //     }
    //   })
    // }
    // if (field == 'alert') {
    //   this.errorCodeList.push({
    //     label: 'DROPDOWN_LIST.NO_ERROR',
    //     value: 'There is no error code',
    //     error_code: 'There is no error code',
    //     timestamp: null,
    //     is_smart_alert: false
    //   })
    // }else{

    // }
    this.errorCodeList = this.errorCodeList?.filter((v, i, a) => a.findIndex(t => (t.value === v.value)) === i)

    this.errorCodeList?.forEach(elem => {
      if (this.errorCd == elem.error_code && elem.error_code != null) {
        elem.active = true
      }
    })
  }

  setOptionalData(field, data) {
    let name;
    let job;
    let custId;
    let newCust = { label: "DROPDOWN_LIST.ADD_NEW_CONTACT", value: 'new', contact: true }
    if (field == 'contact') {

      data?.customer_contacts.map(elem => {
        name = elem.first_name + " " + elem.last_name
        job = elem.job_titles[0]?.name;
        custId = elem.customer_contact_id;
        this.caseContactList.push({
          label: name,
          value: custId,
          cust_id: custId,
          user_role: job
        })
      })
      this.sortList(this.caseContactList)
      this.caseContactList.push(newCust)
    }

    if (field == 'assign') {
      this.assingToList = []
      this.currentUser = []
      data.forEach(item => {
        if (item.user_id != this.commService.custID) {
          this.assingToList.push({ label: item.name, value: item.user_id, assignee_id: item.user_id, assignee_name: item.name })
        } else {
          this.currentUser.push({ label: (this.translate.instant('ME')), value: item.name, assignee_id: item.user_id })
        }
      })
    }

    this.sortList(this.assingToList)
    this.assingToList = this.currentUser.concat(this.assingToList)
    this.assingToList = this.assingToList.filter((v, i, a) => a.findIndex(t => (t.assignee_id === v.assignee_id)) === i)
  }

  getStatus(field) {

    if (field == 'maint') {
      if (this.selectedCase.length > 0 && this.selectedCase[0].value == 'Maintenance') {
        return true
      }
    }

    if (field == 'bnf') {
      if (this.dialogData?.value?.ruleType == 'TargetedAction' || this.dialogData?.value?.ruleType == "Targeted Actions") {
        return false
      }

      if (this.dialogData?.value?.ruleType == "FWupgrade" || this.dialogData?.value?.ruleType == "Firmware Update") {
        return false
      }

      if (this.selectedCase.length > 0 && this.selectedCase[0].value == 'Break & Fix') {
        return true
      }
    }

    if (field == 'target') {
      if (this.selectedCase.length > 0 && this.selectedCase[0].value == 'Targeted Actions') {
        return true
      }
      if (this.selectedCaseType.length > 0 && this.selectedCaseType[0].code == 'Targeted Actions') {
        return true
      }
    }
  }


  get isButtonDisabled() {
    if (this.hasCutter) {
      return this.buttonDisabledForCutter()
    } else {
      return this.buttonDisabledForNonCutter()
    }
  }

  buttonDisabledForCutter() {
    if (this.pageNumber == 1 && (this.selectedCompany.length > 0 && this.selectedDeviceType.length > 0)) {
      if (this.selectedDeviceType[0]?.value == "Printer" && this.selectedPrinter.length > 0 && this.selectedPrinterFunc.length > 0) {
        return false
      } else if (this.selectedDeviceType[0]?.value == "Printer and cutter" && this.selectedPrinter.length > 0 && this.selectedProblemLoc.length > 0 && (this.selectedDeviceFunc.length > 0 || this.selectedPrinterFuncCopy.length > 0)) {
        return false
      } else if (this.selectedDeviceType[0]?.value == "Cutter" && this.selectedPrinter.length > 0 && this.selectedDeviceFunc.length > 0) {
        return false
      }
    } else if (this.pageNumber == 2) {
      if (this.selectedCutterCaseType.length > 0 && this.page1Form.valid) {
        return false
      }
      if (((this.selectedCase.length > 0 || this.selectedCaseType.length > 0) && this.page1Form.valid) && this.checkValidity() && !this.isLoading) {
        if ((this.selectedCase[0]?.value == 'Break & Fix' || this.selectedCase[0]?.value == 'Maintenance') && (this.selectedErrorCode?.length > 0 || this.selectedMaintenance?.length > 0)) {
          return false
        } else if ((this.selectedCase[0]?.value == 'Targeted Actions' && this.selectedTarget.length > 0) || this.selectedCase[0]?.value == 'Firmware Update' || this.selectedCase[0]?.value == 'Other') {
          return false
        }
      }
    }

    return true
  }

  buttonDisabledForNonCutter() {
    if (this.pageNumber == 1 && (this.selectedCompany.length > 0 && this.selectedPrinter.length > 0 && this.selectedPrinterFunc.length > 0)) {
      return false
    } else if (this.pageNumber == 2 && ((this.selectedCase.length > 0 || this.selectedCaseType.length > 0) && this.page1Form.valid) && this.checkValidity() && !this.isLoading) {
      if ((this.selectedCase[0]?.value == 'Break & Fix' || this.selectedCase[0]?.value == 'Maintenance') && (this.selectedErrorCode?.length > 0 || this.selectedMaintenance?.length > 0)) {
        return false
      } else if ((this.selectedCase[0]?.value == 'Targeted Actions' && this.selectedTarget.length > 0) || this.selectedCase[0]?.value == 'Firmware Update' || this.selectedCase[0]?.value == 'Other') {
        return false
      } else {
        return true
      }
    }
    else { return true }
  }


  getProactiveAlerts() {

    if (this.dialogData.value.ruleType == 'Targeted Actions' || this.dialogData.value.ruleType == 'TargetedAction') {
      let targettedArray = []
      targettedArray.push({
        error_code: this.selectedTarget[0]?.value,
        event_name: null,
        is_smart_alert: false,
        action_id: this.dialogData?.value?.actionUuid
      })
      return targettedArray;

    } else if (this.dialogData.value.ruleType == 'Firmware Update' || this.dialogData.value.ruleType == "FWupgrade") {
      let firmArray = []
      firmArray.push({
        error_code: "Unknown",
        event_name: null,
        is_smart_alert: false,
        action_id: this.dialogData?.value?.actionUuid
      })
      return firmArray;

    } else {
      for (let i = 0; i < this.selectedErrorCode?.length; i++) {
        this.alertArray.push({
          error_code: this.selectedErrorCode.length > 0 ? this.selectedErrorCode[i].error_code : null,
          event_name: this.selectedErrorCode.length > 0 ? this.selectedErrorCode[i].event : null,
          user_closable: this.dialogData?.value?.userClosable,
          is_smart_alert: this.selectedCaseType[0]?.value == 'systemerrors' ? true : false,
          timestamp: this.selectedErrorCode.length > 0 ? this.selectedErrorCode[i].timestamp : null,
          action_id: this.dialogData?.proactive == 'proactive' ? this.dialogData?.value?.actionUuid : this.alertID
        })
      }
      return this.alertArray
    }
  }

  getAlerts(field) {
    if (field == "Targeted Actions") {
      let targettedArray = []
      targettedArray.push({
        error_code: this.selectedTarget[0]?.value,
        event_name: null,
        is_smart_alert: false
      })
      return targettedArray;
    }
    if (field == "Maintenance") {
      let maintenance = []
      this.selectedMaintenance?.map(elem => {
        maintenance.push({
          error_code: elem?.error_code,
          event_name: elem?.error_code,
          is_smart_alert: elem?.is_smart_alert ? elem?.is_smart_alert : false
        })
      })
      return maintenance
    }
    if (field == "Break & Fix") {
      for (let i = 0; i < this.selectedErrorCode?.length; i++) {
        this.alertArray.push({
          error_code: this.selectedErrorCode.length > 0 ? this.selectedErrorCode[i].error_code : null,
          event_name: this.selectedErrorCode.length > 0 ? this.selectedErrorCode[i].event : null,
          is_smart_alert: this.selectedErrorCode.length > 0 ? this.selectedErrorCode[i].is_smart_alert : null,
          timestamp: this.selectedErrorCode.length > 0 ? this.selectedErrorCode[i].timestamp : null,
          alert_id: this.isProactive ? this.alertID : null
        })
      }
    }
    return this.alertArray
  }

  saveContact() {

    if (this.isNewContact) {
      let body;
      body = {
        first_name: this.customerDetailForm.get('fname').value,
        last_name: this.customerDetailForm.get('lname').value,
        email: this.customerDetailForm.get('email').value,
        phone: this.customerDetailForm.get('phone').value,
        customer_organization_id: this.selectedCompany[0].c_id,
        selected_job_titles: [
          this.selectedJob[0].value
        ]
      }

      // this.isLoading = true;
      this.showVeenerLoader = true;
      this.caseService.createCustomerContact(body).subscribe(resp => {
        this.newCustContactID = resp.result.customer_contact_id
        this.saveData()
      })
    } else {
      this.saveData();
    }
  }

  saveData() {

    // this.isLoading = true;
    this.showVeenerLoader = true;
    if (this.newCustContactID?.length == 0) {
      this.newCustContactID = this.selectedContact[0]?.cust_id;
    }
    this.body = {
      cutomer_id: this.selectedCompany[0].c_id,
      hp_case: {
        case_details_description: this.detail,
        case_details_subject: this.subject,
        device_status: (this.selectedDeviceType[0]?.value == 'Printer') ? this.selectedPrinterFunc[0]?.value : (this.selectedDeviceFunc[0]?.value || this.selectedPrinterFuncCopy[0]?.value),
        is_proactive: this.isProactive,
        product_number: this.product_number,
        serial_number: this.serial_number,
        origin: this.origin,
        service_type: this.dialogData?.proactive == 'proactive' ? this.selectedCaseType[0]?.code : ((this.selectedProblemLoc[0]?.value == 'Printer' || this.selectedDeviceType[0]?.value == 'Printer') ? this.selectedCase[0]?.value : this.selectedCutterCaseType[0]?.value),
        alerts: this.dialogData?.proactive == 'proactive' ? this.getProactiveAlerts() : ((this.selectedProblemLoc[0]?.value == 'Printer' || this.selectedDeviceType[0]?.value == 'Printer') ? this.getAlerts(this.selectedCase[0].value) : []),
        device_id: this.selectedPrinter[0].device_id,
        customer_contact_id: this.newCustContactID,
        user_id: this.selectedAssignee.length > 0 ? this.selectedAssignee[0].assignee_id : null,
        assigned_user: this.selectedAssignee.length > 0 ? this.selectedAssignee[0].assignee_name : null,
        assigned_user_id: this.selectedAssignee.length > 0 ? this.selectedAssignee[0].assignee_id : null,
        device_type: this.hasCutter ? this.selectedDeviceType[0]?.code : 'printer',
        problem_location: this.hasCutter ? this.selectedProblemLoc[0]?.value?.toLowerCase() : null,
        is_printos: this.selectedPrinter[0].is_printos,

      }
      // hp_case: {
      //   case_details_description: this.detail,
      //   case_details_subject: this.subject,
      //   device_status: this.selectedPrinterFunc[0].value,
      //   is_proactive: this.isProactive,
      //   product_number: this.product_number,
      //   serial_number: this.serial_number,
      //   origin: this.origin,
      //   service_type: this.dialogData?.proactive == 'proactive' ? this.selectedCaseType[0]?.code : this.selectedCase[0].value,
      //   alerts: this.dialogData?.proactive == 'proactive' ? this.getProactiveAlerts() : this.getAlerts(this.selectedCase[0].value),
      //   device_id: this.selectedPrinter[0].device_id,
      //   customer_contact_id: this.newCustContactID,
      //   user_id: this.selectedAssignee.length > 0 ? this.selectedAssignee[0].assignee_id : null,
      //   assigned_user: this.selectedAssignee.length > 0 ? this.selectedAssignee[0].assignee_name : null,
      //   assigned_user_id: this.selectedAssignee.length > 0 ? this.selectedAssignee[0].assignee_id : null
      // }

    }


    this.caseService.createCase(this.body).subscribe(res => {
      if (res.result_status) {
        if (this.isCustomerDetail) {
          this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Create a case', `from customer detail | ${this.getAlerts(this.selectedCase[0]?.value)[0]?.error_code} | ${this.product_number} | ${this.serial_number}`, null);
        } else if (this.isProactive && this.dialogData?.proactive != 'proactive') {
          this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Create a case', `from proactive action | ${this.getAlerts(this.selectedCase[0]?.value)[0]?.error_code} | ${this.product_number} | ${this.serial_number}`, null);
        } else {
          this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Create a case', `from case list | ${this.getAlerts(this.selectedCase[0]?.value)[0]?.error_code} | ${this.product_number} | ${this.serial_number}`, null);
        }
        this.newCaseId = res.result.new_case_id
        let successMessage = this.translate.instant("CASE_CREATED_SUCCESSFULLY", { newCaseId: 'SC' + this.newCaseId })
        let successfulllyAssigned = this.translate.instant("CASE_SUCCESFULLY_ASSIGNED")
        // this.isLoading = false;
        this.showVeenerLoader = false;
        this.caseService.newCaseId = this.newCaseId;
        this.dialogRef.close({ status: 'reload', newCaseID: this.newCaseId })
        this.openModal(true, this.CASE_CREATED, res.result?.assign_case_status ? successMessage + '. ' + successfulllyAssigned + '.' : successMessage)

      } else {
        // this.isLoading = false;
        this.showVeenerLoader = false;
        this.caseService.newCaseId = this.newCaseId;
        this.dialogRef.close({ status: 'reload', newCaseID: this.newCaseId })
        this.openModal(false, "HISTORY_PAGE.ALERT_HISTORY.LEGENDS.ERROR", res.result?.message ? res.result?.message : "Internal server error")
      }
    }, err => {
      // this.isLoading = false;
      this.showVeenerLoader = false;
      this.dialogRef.close({ status: 'reload', newCaseID: this.newCaseId })

      this.openModal(false, "HISTORY_PAGE.ALERT_HISTORY.LEGENDS.ERROR", err?.error?.result?.message ? err?.error?.result?.message : "Internal server error")
    })
  }

  openModal(succeed, title, body) {
    const ref = this.dialog.open(AcceptModalComponent, {
      panelClass: 'accept-dailog',
      backdropClass: 'dialog-backdrop',
      disableClose: true,
      maxWidth: '450px',
      data: {
        title: title,
        body: body,
        isOkay: true,
        hasOrderParts: succeed ? true : false,
      }
    });

    ref.afterClosed().subscribe(data => {
      if (succeed) {
        this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Click on the OK button', this.commService.custID, null)
      }
      if (data == 'orderParts') {
        this.orderParts()
      }
    })
  }

  orderParts() {
    let configurationData = this.commService?.userInfo?.organization
    let params = {
      partner_id: configurationData?.internal_id,
      organization_id: configurationData?.organization_id,
      org_name: configurationData?.name
    }
    this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Go to CSDP Clicked', `From create case | ${this.newCaseId}`, null)

    this.commService.orderParts(params).subscribe(res => {
      this.showConfrimation(true, 'Warning', res)
    }, err => {
      let message = err?.error?.result?.message;
      this.showConfrimation(false, message, null)
      let newTitle = message.toLowerCase()
      let strTitle = this.commService.getTitleAndBody(newTitle, '').title
      if (strTitle) {
        this.googleAnalyticsEventsService.emitEvent('reseller-portal', `Order parts error : ${message}`, `From create case | ${this.newCaseId}`, null)
      }
      // this.commService.failedModal(message);
    })
  }

  dropStatus(field, value) {
    switch (field) {
      case 'company':
        this.companyStatus = false;
        this.modelStatus = this.functionStatus = value;
        break;
      case 'model':
        this.modelStatus = false;
        this.companyStatus = this.functionStatus = value;
        break;
      case 'func':
        this.functionStatus = false;
        this.modelStatus = this.companyStatus = value;
        break;
      case 'case':
        this.typeStatus = false;
        this.maintStatus = this.errorStatus = this.jobStatus = this.contactStatus = this.assignStatus = value;
        break;
      case 'maint':
        this.maintStatus = false;
        this.typeStatus = this.errorStatus = this.jobStatus = this.contactStatus = this.assignStatus = value;
        break;
      case 'error':
        this.errorStatus = false;
        this.maintStatus = this.typeStatus = this.jobStatus = this.contactStatus = this.assignStatus = value;
        break;
      case 'contact':
        this.contactStatus = false;
        this.maintStatus = this.errorStatus = this.jobStatus = this.typeStatus = this.assignStatus = value;
        break;
      case 'job':
        this.jobStatus = false;
        this.maintStatus = this.errorStatus = this.typeStatus = this.contactStatus = this.assignStatus = value;
        break;
      case 'assign':
        this.assignStatus = false;
        this.maintStatus = this.errorStatus = this.jobStatus = this.contactStatus = this.typeStatus = value;
        break;
    }
  }
  fieldHasValue(key) {
    if (key == 'subject') {
      this.subject = this.page1Form?.get(key).value;
    } else {
      this.detail = this.page1Form?.get(key).value;
    }
    return this.page1Form?.get(key).value;
  }
  customerData(key) {
    return this.customerDetailForm.get(key).value;
  }

  showConfrimation(isSuccess, title, res) {
    let newTitle = title.toLowerCase()
    let newBody = ''
    let strTitle = this.commService.getTitleAndBody(newTitle, newBody).title
    newBody = this.commService.getTitleAndBody(newTitle, newBody).newBody
    const ref = this.dialog.open(AcceptModalComponent, {
      panelClass: 'accept-dailog',
      backdropClass: 'dialog-backdrop',
      disableClose: true,
      maxWidth: '450px',
      data: {
        title: strTitle,
        body: newBody,
        isOkay: true,
        customString: 'CONTINUE'
      }
    });

    ref.afterClosed().subscribe(data => {
      if (isSuccess) {
        const link = document.createElement('a');
        link.target = '_blank';
        link.href = res?.result?.url;
        link.setAttribute('visibility', 'hidden');
        link.click();
        this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Continue Clicked', `From create case | ${this.newCaseId}`, null)

      }
    })
  }
}
